import { Popover as PopoverRoot, PopoverTrigger, PopoverContent } from '@bpinternal/ui-kit-next'
import { ComponentProps } from 'react'

type Props = {
  children?: React.ReactNode
  trigger: React.ReactNode
} & Pick<ComponentProps<typeof PopoverRoot>, 'defaultOpen' | 'modal' | 'onOpenChange' | 'open'> &
  ComponentProps<typeof PopoverContent>

export const Popover = ({ children, trigger, defaultOpen, modal, onOpenChange, open, ...props }: Props) => {
  return (
    <PopoverRoot {...{ defaultOpen, modal, onOpenChange, open }}>
      <PopoverTrigger>{trigger}</PopoverTrigger>
      <PopoverContent {...props}>{children}</PopoverContent>
    </PopoverRoot>
  )
}
